import { BANDS, BAND_LABELS, LEGEND_CAPTIONS } from '../helpers';
import { cn } from '@/helpers/shadcn';

// What the cell colours mean on the current scale, plus the two cells that carry no colour.
const Legend = ({ scale }) => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted-foreground" data-testid="feature-usage-legend">
    <span>{LEGEND_CAPTIONS[scale]}</span>
    <div className="flex gap-0.5">
      {BANDS.map((band, i) => (
        <div key={band} className="flex flex-col items-center gap-1">
          <div className={cn('h-3 w-14 rounded-sm', band, i === 0 && 'rounded-l', i === BANDS.length - 1 && 'rounded-r')} />
          <span className="whitespace-nowrap text-[10px] leading-none">{BAND_LABELS[scale][i]}</span>
        </div>
      ))}
    </div>
    <div className="flex items-center gap-1.5">
      <div className="h-3 w-5 rounded-sm border" />
      Not used
    </div>
    <div className="flex items-center gap-1.5">
      <div className="flex h-3 w-5 items-center justify-center rounded-sm bg-muted text-[10px] leading-none">—</div>
      Not tracked
    </div>
  </div>
);

export default Legend;
